import React, { useState } from "react";
import { getDocumentUrl } from "../../requests/documents";
import { FileUpload } from "qjumpers.common.ui";

const FileUploadWrapper = (props) => {
  const [document, setDocument] = useState();

  const downloadDoc = (id) => {
    getDocumentUrl(id).then((result) => {
      setDocument(result?.data);
    });
  };

  return (
    <>
      <FileUpload {...props} getDocumentUrl={downloadDoc} document={document} />
    </>
  );
};

export default FileUploadWrapper;
